// import Swiper from 'swiper/dist/js/swiper';
import Swiper from 'swiper';

function SwiperCtrl() {
	this.init()
}

SwiperCtrl.prototype.init = function () {
	this.front()
}

SwiperCtrl.prototype.front = function () {
	const homeVisual = new Swiper('.home-visual-slider', {
		loop: true,
		speed: 3000,
		autoplay: {
			delay: 10000,
			disableOnInteraction: false
		},
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		}
	});
}

export default SwiperCtrl;